import { SenderProperty } from "./message.model";

export class ConversationTagModel {
    _id?: any;
    uuid: string;
    conversation_uuid: string;
    session_uuid : string;
    sender_property:SenderProperty;
    revision: string;
    status: string;
    vrsn: string;
    create_date: Date;
    update_date: Date;
    created_by: string;
    updated_by: string;
    tag : string;
    description : string;
    project_guid: string;
}
